import * as React from "react";

interface EditorLayoutProps {
  header: React.ReactNode;
  children: React.ReactNode;
  sidebar: React.ReactNode;
}

/**
 * EditorLayout - Responsive layout for quote/template editor
 *
 * - Mobile/Tablet: Single column, sidebar content appears inline
 * - Desktop (XL): Two column layout with sticky sidebar
 */
export const EditorLayout: React.FC<EditorLayoutProps> = ({
  header,
  children,
  sidebar,
}) => {
  return (
    <div className="flex flex-col h-full">
      {/* Fixed Header */}
      <div className="flex-shrink-0 bg-white border-b border-gray-200 px-6 py-3">
        {header}
      </div>

      {/* Content Area */}
      <div className="flex-1 overflow-hidden">
        <div className="h-full grid grid-cols-1 xl:grid-cols-[1fr_400px] bg-white">
          {/* Left column - form content */}
          <div className="overflow-y-auto p-6">{children}</div>

          {/* Right column - sidebar for large screens only */}
          <div className="hidden xl:block bg-gray-50 border-l border-gray-200">
            <div className="h-full overflow-y-auto p-6">{sidebar}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
